export default __webpack_public_path__ + "static/media/clouds-and-sun.610e2950.png";